import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@ui/tooltip/Tooltip';
import Button from '@stone/ui/button/Button';
import Icon from '@stone/ui/icon/Icon';
const ProductBoutiqueSelected = (props) => {
    const { store, onArrowBack, withBorder } = props;
    const { t } = useTranslation();
    if (!store) {
        return React.createElement(React.Fragment, null);
    }
    const renderFromPage = () => (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-24 col-lg-12" },
            React.createElement("p", { className: "store-name" }, store.name)),
        React.createElement("div", { className: "col-24 col-lg-12" },
            React.createElement("p", { className: "store-address" },
                store.address1,
                " ",
                store.address2,
                " ",
                store.city,
                React.createElement("br", null),
                store.phone))));
    const renderFromModal = () => (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-24 col-lg-12" },
            React.createElement("p", { className: "store-name" }, store.name),
            React.createElement("p", { className: "store-address" },
                store.address1,
                " ",
                store.address2,
                " ",
                store.city,
                store.phone && (React.createElement(React.Fragment, null,
                    ', ',
                    React.createElement("span", { className: "store-phone" }, store.phone)))))));
    return (React.createElement("div", { className: classNames('product-reserve__detail__selected-store', { 'has-back': !!onArrowBack }, { 'with-border': withBorder }) },
        !!onArrowBack && (React.createElement(Button, { cls: ['button--link'], type: "button", className: "button-back", "aria-label": t('button.back'), onClick: () => {
                onArrowBack();
            } },
            React.createElement(React.Fragment, null,
                React.createElement(Icon, { ariaHidden: true, family: "10", name: "left-chevron" }),
                t('label.back')))),
        props.appointmentType == 552250001 && store.liveBoutique && (React.createElement("div", { className: "option-store__live-boutique" },
            React.createElement("span", { className: "primary-xxs" }, t('bookanappointment.liveboutique')),
            React.createElement(Tooltip, { ariaLabel: t('label.info'), checkout: true, id: `${store.ID}-live-boutique-info`, icon: "info", className: "live-boutique-info", text: t('bookanappointment.liveboutiquetoltip', { 0: window.liveBoutiqueUrl }) }))),
        props.type == 'page' && renderFromPage(),
        props.type == 'modal' && renderFromModal()));
};
ProductBoutiqueSelected.defaultProps = {
    type: 'page',
};
export default ProductBoutiqueSelected;
